<script>
import AppSingleColumn from "./AppSingleColumn.vue";
import AppImageToSide from "./AppImageToSide.vue";
import AppImageToSideBleed from "./AppImageToSideBleed.vue";
import SlideShow from "./AppSlideShow.vue";
import FullBleedVideo from "./FullBleedVideo.vue";
export default {
  name: "launchSection",
  components: {
    AppSingleColumn,
    SlideShow,
    AppImageToSide,
    FullBleedVideo,
    AppImageToSideBleed,
  },
  data() {
    return {
      langsToHideBanners: ["de-DE", "de-CH", "de-AT", "fr-CH", "pt-BR", "ja-JP"],
      langsWithSolibri: ["en-US",
        "es-US",
        "en-GB",
        "en-FI",
        "fi-FI",
        "sv-SE",
        "da-DK",]
    };
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showBanner() {
      const rootLang = document.documentElement.lang;
      let isVisible = true;
      if (
        this.langsToHideBanners.includes(rootLang) &&
        this.content.background === "darkest"
      ) {
        isVisible = false;
      }
      return isVisible;
    },
  },
  methods: {
    surfacePicker() {
      if (this.content.background === "dark") {
        return "vw-dark-surface";
      } else if (this.content.background === "darkest") {
        return "vw-darkest-surface";
      } else {
        return "";
      }
    },
    showBlock(index = 0, blockLocales) {

      const rootLang = document.documentElement.lang;

      if (blockLocales === undefined) {
        return true
      }
      else {
        if (blockLocales.includes(rootLang)) {
          return true
        }
        else if (blockLocales[0] === 'no-show') {
          return false
        }
        else {
          return false
        }

      }

      // this.langsWithSolibri.includes(rootLang) === false
      // if (this.sectionIndex === 2 && index === 8 && !this.langsWithSolibri.includes(rootLang)) {
      //   return false
      // }

    }
  },
};
</script>
<template>
  <section v-if="showBanner" :id="content.id" :class="surfacePicker()" class="section-wrapper">
    <component :id="block.anchor" v-for="(block, index) in content.blocks" :is="block.blockType" :key="index"
      :content="block.blockContent" v-if="showBlock(index, block.blockContent.locales)" :index="index" />
  </section>
</template>

<style lang="scss" scoped>
@import "../styles/01-settings/breakpoints";
@import "../styles/01-settings/mq";

.section-wrapper {
  --section-padding: 70px;
  overflow-x: hidden;
  background-color: var(--background-color);
  padding-top: var(--section-padding);
  transition: filter 0.3s ease-in-out;
}

@include mq($from: sm, $until: md) {
  .section-wrapper {
    --section-padding: 90px;
  }
}

@include mq($from: md) {
  .section-wrapper {
    --section-padding: 125px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppSection.vue